import React, { useEffect, useState } from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header/Header'
import './Pricing.css'
import { Accordion, Container } from 'react-bootstrap';

function Pricing() {
    const pricingData = {
        monthly: [
            {
                name: "Free",
                price: "$0 / month",
                buttonText: "Get Started for Free",
                features: [
                    "Access to core AI tools",
                    "Upload files (PDF, Excel, CSV)",
                    "Save up to 5 prompts",
                    "Up to 10 chat sessions/month",
                ],
            },
            {
                name: "Business",
                price: "$20 / user / month",
                buttonText: "Start Business Plan",
                recommended: true,
                features: [
                    "All Free features",
                    "Unlimited chats",
                    "Data connectors (DB, Sheets)",
                    "SSO & 2FA security",
                    "Priority email support",
                ],
            },
            {
                name: "Enterprise",
                price: "Custom Pricing",
                buttonText: "Contact Sales",
                features: [
                    "All Free features",
                    "Unlimited chats",
                    "Data connectors (DB, Sheets)",
                    "SSO & 2FA security",
                    "Priority email support",
                ],
            },
        ],
        annually: [
            {
                name: "Free",
                price: "$0 / year",
                buttonText: "Get Started for Free",
                features: [
                    "Access to core AI tools",
                    "Upload files (PDF, Excel, CSV)",
                    "Save up to 5 prompts",
                    "Up to 10 chat sessions/month",
                ],
            },
            {
                name: "Business",
                price: "$200 / user / year",
                buttonText: "Start Business Plan",
                recommended: true,
                features: [
                    "All Free features",
                    "Unlimited chats",
                    "Data connectors (DB, Sheets)",
                    "SSO & 2FA security",
                    "Priority email support",
                ],
            },
            {
                name: "Enterprise",
                price: "Custom Pricing",
                buttonText: "Contact Sales",
                features: [
                    "All Free features",
                    "Unlimited chats",
                    "Data connectors (DB, Sheets)",
                    "SSO & 2FA security",
                    "Priority email support",
                ],
            },
        ],
    };
    const planData = {
        headers: ["Features", "Free", "Business", "Enterprise"],
        sections: [
            {
                title: "Core AI Features",
                features: [
                    { name: "AI Models", values: ["Default", "+GPT 4.1 and 4o, o4-mini and o3-mini; Claude 3.7 and 3.5 Sonnet", "All + bring your own models"] },
                    { name: "File Access", values: ["✔", "✔", "✔"] },
                    { name: "System Memory", values: ["Basic", "Enhanced", "Advanced"] },
                    { name: "Advanced Reasoning", values: ["✖", "✔", "✔"] },
                    { name: "Session Time", values: ["Short", "Standard", "Extended"] },
                    { name: "Saved Prompts", values: ["Up to 5", "Unlimited", "Unlimited"] },
                ],
            },
            {
                title: "Connectivity & Automation",
                features: [
                    { name: "Database Connections", values: ["✔", "✔", "✔"] },
                    { name: "Notifications", values: ["✔", "✔", "✔"] },
                    { name: "SSO", values: ["✖", "✔", "✔"] },
                ],
            },
            {
                title: "Security & Support",
                features: [
                    { name: "2FA", values: ["✔", "✔", "✔"] },
                    { name: "Priority Support", values: ["✖", "✔", "✔"] },
                ],
            },
        ],
    }; const faqs = [
        {
            question: "What’s included in the Free plan?",
            answer:
                "You get access to core AI tools, file uploads (PDF, Excel, CSV), 10 chat sessions per month, and can save up to 5 prompts.",
        },
        {
            question: "Can I upgrade, downgrade, or cancel my plan anytime?",
            answer: "Yes, you can manage your plan anytime from your account settings.",
        },
        {
            question: "Do you offer annual billing discounts?",
            answer: "Yes, annual plans come with discounted pricing compared to monthly.",
        },
        {
            question: "What payment methods do you accept?",
            answer: "We accept credit cards, debit cards, and corporate invoicing for Enterprise customers.",
        },
        {
            question: "What happens if I exceed my plan limits?",
            answer: "You'll receive a notification, and you can choose to upgrade to continue using all features.",
        },
        {
            question: "What’s included in Enterprise support?",
            answer: "Enterprise support includes priority email support, dedicated success manager, and advanced security options.",
        },
    ];
    const [billingCycle, setBillingCycle] = useState("monthly");
    const [activePlan, setActivePlan] = useState(null);
    useEffect(() => {
        // Set default selected plan based on recommended
        const recommendedIndex = pricingData[billingCycle].findIndex(plan => plan.recommended);
        setActivePlan(recommendedIndex !== -1 ? recommendedIndex : 0);
    }, [billingCycle]);
    return (
        <div className="home">
            <Header />
            <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
                <h1 className="banner-title w-50">Plans for Every Team, Mission Ready.</h1>
                <p className="banner-description">
                    Whether you’re exploring or scaling, Brainyagent has a plan that
                    fits your workflow, and grows with you.
                </p>

            </div>
            <div className="pricing-container">
                {/* Toggle Switch */}
                <div className="toggle">
                    <button
                        className={billingCycle === "monthly" ? "active" : ""}
                        onClick={() => setBillingCycle("monthly")}
                    >
                        Monthly
                    </button>
                    <button
                        className={billingCycle === "annually" ? "active" : ""}
                        onClick={() => setBillingCycle("annually")}
                    >
                        Annually
                    </button>
                </div>

                <div className="cards">
                    {pricingData[billingCycle].map((plan, index) => (
                        <div
                            key={index}
                            className={`card 
                                 ${activePlan == index ? "selected" : ""}`}
                            onClick={() => setActivePlan(index)}
                        >
                            <h3>{plan.name}</h3>
                            <p className="price mb-2">{plan.price}</p>
                            <button className={`plan-btn ${activePlan == index ? "selected" : ""}`}>{plan.buttonText}</button>
                            <ul>
                                {plan.features.map((f, i) => (
                                    <li key={i}>✓ {f}</li>
                                ))}
                            </ul>
                            {plan.recommended && <span className="tag">Recommended</span>}
                        </div>
                    ))}
                </div>
            </div>
            <div className="comparison-container">
                <h2 className="comparison-title">Compare Plan Features</h2>
                <table className="comparison-table ">
                    <thead>
                        <tr>
                            {planData.headers.map((header, i) => (
                                <th key={i}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {planData.sections.map((section, i) => (
                            <React.Fragment key={i}>
                                {/* Section title row */}
                                <tr className="section-row">
                                    <td colSpan={planData.headers.length}>{section.title}</td>
                                </tr>
                                {/* Feature rows */}
                                {section.features.map((feature, j) => (
                                    <tr key={j}>
                                        <td className="feature-name text-start">{feature.name}</td>
                                        {feature.values.map((val, k) => (
                                            <td
                                                key={k}
                                                className={
                                                    val === "✔"
                                                        ? "check"
                                                        : val === "✖"
                                                            ? "cross"
                                                            : "text"
                                                }
                                            >
                                                {val}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
                <h2 className="accordian-title text-center">
                    Frequently Asked Questions
                </h2>
                <Accordion defaultActiveKey="0" flush style={{width:'100%'}}>
                    {faqs.map((faq, index) => (
                        <Accordion.Item eventKey={index.toString()} key={index} className="mb-3 rounded shadow-sm">
                            <Accordion.Header style={{fontSize:"22px"}}>{faq.question}</Accordion.Header>
                            <Accordion.Body style={{fontSize:"16px",paddingTop:'none'}}>{faq.answer}</Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
            <Footer />
        </div>
    )
}

export default Pricing